import type { PostRecord } from "./schema.ts";
export type { Embed, Facet, PostRecord } from "./schema.ts";

export interface Post {
  uri: string;
  record?: PostRecord;
  error?: string;
}
export interface Author {
  did: string;
  handle?: string;
  displayName?: string;
  avatar?: string;
  pds?: string;
}
export type RecordEvent =
  | { type: "post" | "quote"; post: Post }
  | { type: "author"; author: Author };

export type ThreadEvent =
  | RecordEvent
  | { type: "thread"; selected: string; root: string };

export function quoteUri(record: PostRecord): string | undefined {
  const embed = record.embed;
  if (embed?.$type === "app.bsky.embed.record") return embed.record.uri;
  if (embed?.$type === "app.bsky.embed.recordWithMedia") {
    return embed.record.record.uri;
  }
}
